// Hiperłącza w tytule i opisie zadania — warstwa DOM. Spec: spec/lista-zadan.md,
// "Hiperłącza w tytule i opisie". Tokenizer (testowany): linkify-core.ts.
// Tekst użytkownika renderujemy wyłącznie przez węzły DOM (nigdy innerHTML).

import { findLinks } from './linkify-core.ts';
export { findLinks, type LinkSpan } from './linkify-core.ts';

/**
 * Dokleja do `el` tekst z linkami. Tekst linku pozostaje zwykłym tekstem (klik = edycja pola,
 * jak w każdym innym miejscu tekstu; Ctrl/⌘+klik otwiera), a obok stoi mały przycisk ↗,
 * który otwiera adres w nowej karcie — na dotyku to jedyna droga do linku.
 */
export function appendLinkified(el: HTMLElement, text: string): void {
  let pos = 0;
  for (const link of findLinks(text)) {
    if (link.start > pos) el.appendChild(document.createTextNode(text.slice(pos, link.start)));

    const label = document.createElement('span');
    label.className = 'text-link';
    label.textContent = link.label;
    label.title = link.href + '\nKlik: edytuj pole · Ctrl/⌘+klik: otwórz link · ↗: otwórz link';
    label.addEventListener('click', (e) => {
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault();
        e.stopPropagation();
        window.open(link.href, '_blank', 'noopener');
      }
    });
    el.appendChild(label);

    const open = document.createElement('a');
    open.className = 'text-link-open';
    open.href = link.href;
    open.target = '_blank';
    open.rel = 'noopener noreferrer';
    open.title = 'Otwórz ' + link.href;
    open.setAttribute('aria-label', 'Otwórz link');
    open.textContent = '↗';
    open.addEventListener('click', (e) => e.stopPropagation());
    el.appendChild(open);

    pos = link.end;
  }
  if (pos < text.length) el.appendChild(document.createTextNode(text.slice(pos)));
}

/** Zastępuje zawartość `el` tekstem z linkami. */
export function setLinkified(el: HTMLElement, text: string): void {
  el.textContent = '';
  appendLinkified(el, text);
}
